import { message } from 'antd';
import { runPostingCommand } from './posting';

const printDocument = async (
  type: 'print_service_order' | 'print_sales_receipt' | 'print_tax_invoice',
  orderId: number,
  label: string,
  params?: Record<string, string>,
): Promise<boolean> => {
  const outcome = params
    ? await runPostingCommand(type, orderId, params)
    : await runPostingCommand(type, orderId);
  if (outcome.status === 'done') {
    message.success(outcome.message || `${label} отправлен на принтер`);
    return true;
  }
  if (outcome.status === 'error') {
    message.error(outcome.error || `Не удалось напечатать: ${label}`);
  } else {
    message.warning(outcome.error || '1С не ответила — проверьте агента и принтер на ПК кассира');
  }
  return false;
};

export const printServiceOrderForm = async (orderId: number): Promise<boolean> =>
  printDocument('print_service_order', orderId, 'Наряд-заказ');

export const printSalesReceiptForm = async (orderId: number): Promise<boolean> =>
  printDocument('print_sales_receipt', orderId, 'Товарный чек');

export const printTaxInvoiceForm = async (
  orderId: number,
  documentRole: 'goods' | 'services',
): Promise<boolean> => printDocument(
  'print_tax_invoice',
  orderId,
  documentRole === 'services' ? 'Счёт-фактура услуг' : 'Счёт-фактура запчастей',
  { document_role: documentRole },
);
